import type { User } from '@proposify/users-bff-api-client';

export const isLegacyUserId = (id: string | number | undefined): boolean => /^\d+$/.test(String(id ?? ''));

export function resolveLegacyUserId(id: string | number, users: User[] | undefined): string | undefined {
  if (isLegacyUserId(id)) return String(id);

  const legacyId = users?.find((user) => user.id === id)?.legacy_id;
  return legacyId == null ? undefined : String(legacyId);
}
